module.exports = __webpack_public_path__ + "img/capa-hover-tecnologia.7ca685a3.png";